// utils/device.js
export const isMobileDevice = () => {
  if (typeof navigator === "undefined") return false; // avoid error in SSR
  return /iPhone|iPod|Android/i.test(navigator.userAgent);
};

export const isTabletDevice = () => {
  if (typeof navigator === "undefined") return false;
  return /iPad|Tablet/i.test(navigator.userAgent);
};
